import { RpcRequest } from '@message-bus/core';
import {
  NativeNamespaces,
  SystemNativeMethods,
} from '@mobile-data-access-enums';

@RpcRequest(NativeNamespaces.SYSTEM, SystemNativeMethods.PWA_READY)
export class MarkPwaReadyMethod {}
